<i18n>
{
"en": {
  "MANAGEUSER": "Manage User",
  "FIRSTNAME(ARABIC)": "First Name (Arabic)",
  "FATHERNAME": "Father Name",
  "FATHERNAME(ARABIC)": "Father Name (Arabic)",
  "LASTNAME(ARABIC)": "Last Name (Arabic)",
  "FIRSTNAME": "First Name",
  "LASTNAME": "Last Name",
  "GENDER": "Gender",
  "LOADING": "Loading...",
  "UPLOADIMAGE": "Upload Image",
  "SAVEIMAGE": "Save Image",
  "MALE": "Male",
  "FEMALE": "Female",
  "IDNUMBER": "ID Number",
  "IDEXPIRATIONDATE": "ID Expiration Date",
  "PICKADATE": "Pick a date",
  "NATIONALITY": "Nationality",
  "PLEASESELECTNATIONALITY": "Please select nationality",
  "CONTACTINFO": "Contact Info",
  "MOBILENO": "Mobile No",
  "EMAILADDRESS": "Email Address",
  "LANDLINEPHONE": "Landline Phone",
  "ACCOUNTLOGIN": "Account Login",
  "USERNAME(EMAILADDRESS)": "Username (Email Address)",
  "ENTERUSERNAME": "Enter username",
  "CHANGEPASSWORD": "Change Password",
  "ENTERPASSWORD": "Enter Password",
  "CANNOTBEEMPTY": "Can not be empty",
  "MUSTLOWERCASE": "must contain at least 1 lowercase alphabetical character",
  "MUSTUPPERCASE": "must contain at least 1 uppercase alphabetical character",
  "MUSTNUMERIC": "must contain at least 1 numeric character",
  "MUSTSPECIAL": "must contain at least one special character",
  "ATLEASTCHARACTERS": "must contain at least 8 characters",
  "ROLE": "Role",
  "CONTACTINFO": "Contact Info",
  "PASSWORDVALIDATION": "must contain at least 6 characters long, one upper case letter, one lower case letter, and one numeric digit.",
  "ISREQUIRED": "is required.",
  "MUSTBEATLEASTCHARACTERSINLENGTH": "must be at least {len} characters in length.",
  "CANNOTEXCEEDCHARACTERSINLENGTH": "cannot exceed {len} characters in length.",
  "ISNOTAVALIDFORMAT": "is not a valid format. Only letters, spaces and dashes are allowed.",
  "ISNOTAVALIDARABICFORMAT": "is not a valid arabic format.",
  "INVALIDPHONENO": "is invalid phone number.",
  "ALREADYEXISTED": "already existed.",
  "ERROR": "Error",
  "CLOSE": "Close",
  "MUSTCONTAINAVALIDEMAILADDRESS": "must contain a valid email address.",
  "LEVEL": "Level"
},
"ar":{
  "MANAGEUSER": "ادارة المستخدمين",
  "FIRSTNAME(ARABIC)": "الاسم الأول (عربي) ",
  "FATHERNAME": "اسم الاب",
  "FATHERNAME(ARABIC)": "اسم الأب (عربي) ",
  "LASTNAME(ARABIC)": " الاسم العائلي (عربي) ",
  "FIRSTNAME": "الأسم الأول",
  "LASTNAME": "الاسم العائلي",
  "GENDER": "جنس",
  "LOADING": "جار التحميل...",
  "UPLOADIMAGE": "تحميل الصور",
  "SAVEIMAGE": "احفظ الصورة",
  "MALE": "ذكر",
  "FEMALE": "أنثى",
  "IDNUMBER":"رقم الهوية",
  "IDEXPIRATIONDATE": "انتهاء صلاحية الهوية",
  "PICKADATE":"اختر تاريخا",
  "NATIONALITY": "الجنسية",
  "PLEASESELECTNATIONALITY": "يرجى تحديد الجنسية",
  "CONTACTINFO": "معلومات الاتصال",
  "MOBILENO": "رقم الجوال",
  "EMAILADDRESS": "عنوان البريد الإلكتروني",
  "LANDLINEPHONE": "الهاتف الثابت",
  "ACCOUNTLOGIN": "بيانات الدخول",
  "USERNAME(EMAILADDRESS)": "اسم المستخدم (عنوان البريد الإلكتروني)",
  "ENTERUSERNAME": "ادخل اسم المستخدم",
  "CHANGEPASSWORD": "تغيير كلمة السر",
  "ENTERPASSWORD": "ادخل كلمة السر",
  "CANNOTBEEMPTY": "لا يمكن أن يكون فارغاً",
  "MUSTLOWERCASE": "يجب أن يحتوي على حرف أبجدي صغير واحد على الأقل",
  "MUSTUPPERCASE": "يجب أن يحتوي على حرف أبجدي كبير واحد على الأقل",
  "MUSTNUMERIC": "يجب أن يحتوي على حرف رقمي واحد على الأقل",
  "MUSTSPECIAL": "يجب أن يحتوي على حرف خاص واحد على الأقل",
  "ATLEASTCHARACTERS": "يجب أن يحتوي على 8 أحرف على الأقل",
  "ROLE": "دور",
  "CONTACTINFO": "معلومات الاتصال",
  "PASSWORDVALIDATION": ".يجب أن يحتوي على 6 أحرف على الأقل ، حرف واحد كبير، حرف واحد صغير، ورقم واحد",
  "ISREQUIRED": ".مطلوب",
  "MUSTBEATLEASTCHARACTERSINLENGTH": ".يجب أن تكون على الأقل {len} حرفا",
  "CANNOTEXCEEDCHARACTERSINLENGTH": ".لا يمكن أن يتجاوز {len} حرفا",
  "ISNOTAVALIDFORMAT": ".ليس شكل صحيح. فقط خطابات، ويسمح للمسافات وشرطات",
  "ISNOTAVALIDARABICFORMAT": ".ليست صيغة عربية صحيحة",
  "INVALIDPHONENO": ".رقم هاتف غير صالح",
  "ALREADYEXISTED": ".موجودة بالفعل",
  "ERROR": "خطأ",
  "CLOSE": "أغلق",
  "MUSTCONTAINAVALIDEMAILADDRESS": ".يجب أن يحتوي على عنوان بريد إلكتروني صالح",
  "LEVEL": "مستوى" 
}
}
</i18n>
<template>
<div class="form"   v-loading="loading" :element-loading-text="$t('LOADING')">
    <el-card class="card-border" ref="card" :body-style="{ padding: 0 }">
      <wi-save slot="header" :form="['mainForm','accountForm','contactForm']" :title="$t('MANAGEUSER')" :data="{person: this.person, user: this.user, contact: this.contact}"></wi-save>
    <el-row>
      <el-col :span="10">
        <el-tabs type="border-card"  class="formTab"  :style="{ height: cardHeight + 'px' }">
        <VuePerfectScrollbar  ref="Scrollbar" class="scrollbar"   v-bind:style="{ height: cardHeight + 'px' }">
          <el-form ref="mainForm" :model="person" label-width="120px" label-position="top">
            <el-row :gutter="20" style="margin-bottom: 20px">
            
              <el-col :span="12">
                <wi-upload :person="person"></wi-upload>   
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('GENDER')" prop="Gender" :rules="{required:true, message:$t('ISREQUIRED'), trigger: 'change'}">
                  <el-radio-group v-model="person.Gender"  size="small">
                    <el-radio-button label="Male">{{$t('MALE')}}</el-radio-button>
                    <el-radio-button label="Female">{{$t('FEMALE')}}</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('FIRSTNAME')" prop="FirstName_EN" :rules="[{required:true, message:$t('ISREQUIRED'), trigger:'blur'},{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input :placeholder="$t('FIRSTNAME')" v-model="person.FirstName_EN"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('FIRSTNAME(ARABIC)')" prop="FirstName_AR" :rules="[{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input :placeholder="$t('FIRSTNAME(ARABIC)')" v-model="person.FirstName_AR"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('FATHERNAME')" prop="MiddleName" :rules="[{required:true, message:$t('ISREQUIRED'), trigger:'blur'},{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input :placeholder="$t('FATHERNAME')" v-model="person.MiddleName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('FATHERNAME(ARABIC)')" prop="MiddleName_AR" :rules="[{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input :placeholder="$t('FATHERNAME(ARABIC)')" v-model="person.MiddleName_AR"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('LASTNAME')" prop="LastName_EN" :rules="[{required:true, message:$t('ISREQUIRED'), trigger:'blur'},{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input :placeholder="$t('LASTNAME')" v-model="person.LastName_EN"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('LASTNAME(ARABIC)')" prop="LastName_AR" :rules="[{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input :placeholder="$t('LASTNAME(ARABIC)')" v-model="person.LastName_AR"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('IDNUMBER')" prop="ExternalPersonID" :rules="[{required:true, message:$t('ISREQUIRED'), trigger:'blur'},{validate: true, message: $t('IDNUMBER') + ' ' + $t('ALREADYEXISTED')},{max:18, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 18}), trigger:'blur'}]">
                  <el-input :placeholder="$t('IDNUMBER')" v-model="person.ExternalPersonID"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('IDEXPIRATIONDATE')" prop="IDExpiration" :rules="{required:false, type:'date', message:$t('ISREQUIRED'), trigger:'blur'}">
                  <el-date-picker type="date" :placeholder="$t('PICKADATE')" format="dd/MM/yyyy" :picker-options="pickerOption" v-model="person.IDExpiration" style="width: 100%"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('NATIONALITY')" prop="Nationality" :rules="{required: true, message:$t('ISREQUIRED'), trigger:'change'}">
                   <el-select   v-model="person.Nationality" :placeholder="$t('PLEASESELECTNATIONALITY')" filterable>
                     <el-option :key="key" v-for="(value, key) in $countries" :label="value" :value="key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

            </el-row>


          </el-form>
            </VuePerfectScrollbar>
        </el-tabs>
      </el-col>
      <el-col :span="14">
        <el-tabs type="border-card" :style="{ height: cardHeight + 'px' }">
                    <el-tab-pane :label="$t('ACCOUNTLOGIN')">
            <el-form ref="accountForm" :model="user" label-width="120px" label-position="top">
                          <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('USERNAME(EMAILADDRESS)')" prop="UserID" :rules="[{required: true, message:$t('ISREQUIRED'), trigger:'blur'},{min:6, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 6}), trigger:'blur'},{type:'email', message:$t('MUSTCONTAINAVALIDEMAILADDRESS'), trigger:'blur'},{max:50, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 50}), trigger:'blur'},{validate: true, message: $t('USERNAME(EMAILADDRESS)') + ' ' + $t('ALREADYEXISTED')}]">
                  <el-input :placeholder="$t('ENTERUSERNAME')" v-model="user.UserID"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('CHANGEPASSWORD')" prop="Password" :rules="{validator:passwordValidation, trigger:'blur'}"  v-show="parseInt(person.PersonID) === parseInt(loggedInUserID)">
                  <el-input type="password" :disabled="editPassword" :icon="editPassword ? 'edit' : 'circle-close'" :on-icon-click="changePassword" :placeholder="$t('ENTERPASSWORD')" v-model="renderPwd"></el-input>
                </el-form-item>
              </el-col>
               <el-col :span="12">
                <el-form-item :label="$t('ROLE')" prop="Level" :rules="{required: true, message:$t('ISREQUIRED'), trigger:'change'}">             
               <el-select v-model="user.Level" class="role"  :disabled="parseInt(person.PersonID) === parseInt(loggedInUserID)">
                    <el-option
                            :key="index" v-for="(level, index) in levels"
                            :label="level.name"
                            :value="level.id">
                      <span>{{ level.name }}</span>
                      <span style="color: #8492a6; font-size: 13px">{{ $t('LEVEL') + ' ' + level.id }}</span>
                    </el-option>
                </el-select>
                </el-form-item>
              </el-col>

            </el-row>
            </el-form>
                    </el-tab-pane>
          <el-tab-pane :label="$t('CONTACTINFO')">
            <el-form ref="contactForm" :model="contact" label-width="120px" label-position="top">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="$t('MOBILENO')" prop="MobilePhone" :rules="[{required: true, message:$t('ISREQUIRED'), trigger:'blur'},{validator:phoneValidation, message:$t('INVALIDPHONENO'), trigger:'blur' }]">
                    <el-input v-model="contact.MobilePhone"></el-input>
                  </el-form-item>
                  <el-input type="hidden"  v-model="contact.EMail" v-bind:value="user.UserID"></el-input>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('LANDLINEPHONE')" prop="LandlinePhone" :rules="{validator:phoneValidation, message:$t('INVALIDPHONENO'), trigger:'blur' }">
                    <el-input v-model="contact.LandlinePhone"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    </el-card>
    <el-dialog
    :title="$t('ERROR')"
    v-model="error"
    size="tiny">

    <div class="el-alert el-alert--error">
      <i class="el-alert__icon el-icon-circle-cross is-big"></i>
      <div class="el-alert__content">
        <span class="el-alert__title is-bold" :key="index" v-for="(messageError, index) in message" v-html="printError(messageError)"></span>
        </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="error = false">{{$t('CLOSE')}}</el-button>
    </span>
  </el-dialog>        
  </div>
</template>
<script>
  
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import WiUpload from '@/components/dialogs/Upload'
  import WiSave from '@/components/dialogs/Save'
  import qs from 'querystring'
  import _ from 'lodash'
  export default {
    components: {VuePerfectScrollbar, 'wi-upload': WiUpload, 'wi-save': WiSave},
    data () {
      return {
        person: {IDExpiration: null, Gender: null, Nationality: null, ImagePath: null},
        user: {Level: null},
        contact: {MobilePhone: null, EMail: null, LandlinePhone: null},
        logs: [],
        loggedInUserID: null,
        levels: [],
        applications: [],
        banned: [],
        school: {},
        address: {},
        relatives: [],
        activeIndex: '',
        handleSelect: '',
        dialogVisible: false,
        dialogImageUrl: '',
        cardHeight: 0,
        loading: false,
        editPassword: true,
        message: null,
        error: false,
        date_format: 'dd/MM/yyyy',
        pickerOption: {
          disabledDate (time) {
            return time.getTime() < Date.now() - 8.64e7
          }
        },
        alreadyExisted: {ID: false, Email: false}
      }
    },
    computed: {
      renderPwd: {
        get () {
          if (this.editPassword) return 'Password'
          return this.user.Password
        },
        set (password) {
          this.user.Password = password
        }
      }
    },
    mounted () {
      this.switchLanguage()
      let userData = JSON.parse(localStorage.getItem('userData'))
      this.loggedInUserID = userData.user_id
      this.date_format = userData.date_format
      this.cardHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53
      this.getLevels()
      this.getUser()
    },
    methods: {
      printError (message) {
        let error = message.split(' ')
        if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], {len: error[2]}) + '</br>'
        return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>'
      },
      phoneValidation (rule, value, callback) {
        let regex = /^\+?[\d-]+$/
        if (value && !regex.test(value)) callback(this.$t('INVALIDPHONENO'))
        callback()
      },
      passwordValidation (rule, value, callback) {
        if (this.editPassword) callback()
        if (_.isEmpty(value)) callback(this.$t('CANNOTBEEMPTY'))
        else {
          if (!new RegExp('(?=.*[a-z])').test(value)) callback(this.$t('MUSTLOWERCASE'))
          else if (!new RegExp('(?=.*[A-Z])').test(value)) callback(this.$t('MUSTUPPERCASE'))
          else if (!new RegExp('(?=.*[0-9])').test(value)) callback(this.$t('MUSTNUMERIC'))
          else if (!new RegExp('(?=.*[!@#\\$%\\^&\\*])').test(value)) callback(this.$t('MUSTSPECIAL'))
          else if (!new RegExp('(?=.{8,})').test(value)) callback(this.$t('ATLEASTCHARACTERS'))
          callback()
        }
      },
      changePassword () {
        this.editPassword = !this.editPassword
        if (this.editPassword) this.$delete(this.user, 'Password')
        this.$refs.accountForm.validateField('Password')
      },
      imageUploaded (res) {
        if (res.file_name !== undefined) this.person.ImagePath = res.file_name
      },
      getUser () {
        let self = this
        if (this.$route.params.id === 'create') return
        this.loading = true
        this.$http.get('/user/' + this.$route.params.id).then(function (response) {
          self.person = response.data.person
          if (self.person.IDExpiration) self.person.IDExpiration = self.dateFormat(self.person.IDExpiration)
          self.user = response.data.user
          self.contact = response.data.contact
          self.loading = false
        }).catch(function (response) {})
      },
      onSubmit () {
        console.log('submit!')
      },
      handlePictureCardPreview (file) {
        this.dialogImageUrl = file.this.URL
        this.dialogVisible = true
      },
      logPath (item) {
        if (item.Method === 'login' || item.Method === 'logout') return '#'
        var method = item.Method === 'save' || item.Method === 'delete' || item.Method === 'saveTagID' ? 'edit' : item.Method
        return '/' + item.Module + '/' + item.Controller + '/' + method + '/' + item.ItemValue
      },
      IsBanned (item) {
        if (this.banned[item.UserID].indexOf(item.IPAddress) < 0) return false
        return true
      },
      IpBan (item) {
        var baseUrl = 'http://localhost/wathiq_web/'
        var resource = baseUrl + 'admin/log/ip_ban'
        var axios = axios.create({
          headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'}
        })
        var IPIndex = this.banned[item.UserID].indexOf(item.IPAddress)
        var status = IPIndex < 0 ? 1 : 0
        var vm = this
        axios.post(resource, qs.stringify({UserID: item.UserID, IPAddress: item.IPAddress, status: status})).then(function (response) {
          if (status !== 1) return vm.banned[item.UserID].splice(IPIndex, 1)
          vm.banned[item.UserID].push(item.IPAddress)
        }).catch(function (response) {
          // error callback
        })
      },
      getLevels () {
        let self = this
        this.$http.get('/role')
            .then(function (response) {
              self.levels = response.data
            })
            .catch(function (error) {
              console.log(error)
            })
      },
      handleAvatarSuccess (res, file) {
        this.student.ImagePath = URL.createObjectURL(file.raw)
      }
    }
  }
</script>

<style>
</style>




// WEBPACK FOOTER //
// UserManage.vue?2dcfce3e